import React from "react";
import styled from "styled-components";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Theme from "../Theme";

export interface IStyledPopper {
  top: number;
  left: number;
  transitionDelay: number;
  transitionDuration: number;
}

const StyledPopper = styled.div<IStyledPopper>`
  position: fixed;
  z-index: 1;
  margin-top: 120px;
  transition-property: left;

  ${props =>
    `
    top: ${props.top || 0}px;
    left: ${props.left || 0}px;
    transition-duration: ${props.transitionDuration}ms;
    transition-delay: ${props.transitionDelay}ms;
  `}
`;

const TabBox = styled.div`
  padding: 3px;
  color: ${Theme.colors.white};
  fill: ${Theme.colors.white};
  background-color: ${Theme.colors.darkBackground};
  border-radius: 0 7px 7px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

interface ICollapseTabProps extends IStyledPopper {
  open: boolean;
  onClick: () => void;
}

const CollapseTab = (props: ICollapseTabProps) => {
  const { top, left, open, onClick, transitionDelay, transitionDuration } = props;

  return (
    <StyledPopper
      top={top}
      left={left}
      onClick={onClick}
      transitionDelay={transitionDelay}
      transitionDuration={transitionDuration}
      title={open ? "Collapse" : "Expand"}
    >
      <TabBox>{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</TabBox>
    </StyledPopper>
  );
};

export default CollapseTab;
